export default {"src":"/_next/static/media/logo.a70260ca.svg","height":35,"width":93};